import { DividingLineElement } from '../../slateTypes';

function dividingLineSerializer(dividingElement: DividingLineElement) {
  const { type } = dividingElement;
  return `{{${type}}}`;
}

export default dividingLineSerializer;
